import { useState, useRef, useEffect } from "react";
import { useAuthHeader, useAuthUser } from "../../../Services/Auth/sessionAuth";
import { Button, Card, Form, Input, Modal, Radio, Space, Spin, Tabs, Tree } from 'antd';
import Utilisateur from "../../../Models/Utilisateur";
import type { TabsProps } from 'antd';
import type { DataNode } from 'antd/es/tree';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined, ProfileOutlined, DeleteOutlined, PlusOutlined, MergeCellsOutlined, SaveOutlined } from '@ant-design/icons';
import SweetAlert from "sweetalert2";
import Swal from "sweetalert2";
import Tab1 from "./Tab1";
import { Box, Grid, Typography } from '@mui/material';
import Tab4 from './Tab1';

import SearchModal from "../../SearchModal";
import InputForm from "../../InputT";
import SelectOption from "../../SelectOption";
import DataSelect from '../../../Types/DataSelect'
import ParamsPicklist from "../../../Types/ParamsPicklist";
import SearInputG from "../../SearchInput"
import { Crypter } from "../../../Functions/Security/Crypter";
import Data from '../../../Data/Data.json';
import axios from "axios";
import ReformatDate from '../../../Functions/Traitement/ReformatDate'
import Demand from '../../../Models/MPlanCp';
import formatDate from "../../../Functions/Traitement/fomatDate";
import { date } from "yup";
import CheckBox from "../../CheckBox";
import type { CheckboxChangeEvent } from 'antd/es/checkbox';


import React from 'react';
import { Checkbox, Col, Row } from 'antd';
import type { CheckboxValueType } from 'antd/es/checkbox/Group';
import CheckboxF from "../../ChexBox";
import CheckStan from "../../Prints/CheckStan";

//pour le CATEGORIE client
let searchCtegoCli: ParamsPicklist = { CodeAgence: 'TYPCLI', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: 'RUBRIQ', Choix: 22 }

//pour le CATEGORIE CPT
let searchCtegoCpt: ParamsPicklist = { CodeAgence: 'CATEGOCPT', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: 'RUBRIQ', Choix: 22 }

//pour le Plancp
let searchPlancp: ParamsPicklist = { CodeAgence: '', Table: "PLANCP", Colonne1: "IDPLAN", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }

// pour les commissions
let searchCommis: ParamsPicklist = { CodeAgence: '', Table: "COMMIS", Colonne1: "CODCOM", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }

// pour les commissions
let searchCommis2: ParamsPicklist = { CodeAgence: '', Table: "OPERAT", Colonne1: "CODOPE", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }



// Type de Type cpt
let searchTypCPT: ParamsPicklist = { CodeAgence: 'TYPCPT', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: 'RUBRIQ', Choix: 22 }

// Type de Frequence cpt
let searchTypFre: ParamsPicklist = { CodeAgence: 'PERIOD', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: 'RUBRIQ', Choix: 22 }

// Type de sens solde
let searchTypSens: ParamsPicklist = { CodeAgence: 'SENSEC', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: 'RUBRIQ', Choix: 22 }

//pour le compte de groupe
let searchcptgrp: ParamsPicklist = { CodeAgence: '', Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: '101', Choix: 22 }

//pour le compte de groupe
let searchTYIN: ParamsPicklist = { CodeAgence: '', Table: "COMMIS", Colonne1: "CODCOM", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }





const PlanCp = () => {

    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const authHeader = useAuthHeader()
    const [Onfinis, SetOnfinis] = useState<number>(0);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [SearchGlobal, setSearchGlobal] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [Consultactv, setConsulte] = useState(false);
    const [Ajoutactv, setAjoute] = useState(false);
    const [Modifactv, setModife] = useState(true);
    const [Supprimactv, setSupprime] = useState(true);
    const [Enregactv, setEnrege] = useState(true);
    const [Actuactv, setActue] = useState(true);
    const [Annulactv, setAnnule] = useState(true);
    const [FormAct, setFormactve] = useState(true);
    const [sbmit, setSbmit] = useState("");
    const [Idbutton, setIdbutton] = useState(false);
    const [activeTab, setActiveTab] = useState('1');

    const [planCpList, setPlanCpList] = useState<{ Code: string; Libelle: string }[]>([]);
    const [planCpTree, setPlanCpTree] = useState<DataNode[]>([]);
    const [selectedParent, setSelectedParent] = useState<string>('');
    const [lastDigit, setLastDigit] = useState<string>('');
    const [addCodeError, setAddCodeError] = useState<string | null>(null);
    const [codeGenVisible, setCodeGenVisible] = useState(false);
    const [treeSearch, setTreeSearch] = useState<string>('');
    const [filteredTree, setFilteredTree] = useState<DataNode[]>([]);
    const [expandedKeys, setExpandedKeys] = useState<React.Key[]>([]);

    const [Activetabs, SetActivetabs] = useState(false);
    const onChange = (e: CheckboxChangeEvent) => {
        console.log(`checked = ${e.target.checked}`);
    };

    const buildPlanCpTree = (list: { Code: string; Libelle: string }[]): DataNode[] => {
        const map: Record<string, DataNode> = {};
        list.forEach(item => {
            map[item.Code] = { title: `${item.Code} - ${item.Libelle}`, key: item.Code, children: [] };
        });
        const roots: DataNode[] = [];
        list.forEach(item => {
            const code = item.Code;
            let parentCode = '';
            for (let i = 1; i < code.length; i++) {
                const prefix = code.slice(0, -i);
                if (map[prefix]) { parentCode = prefix; break; }
            }
            if (parentCode) {
                map[parentCode].children!.push(map[code]);
            } else {
                roots.push(map[code]);
            }
        });
        const clean = (node: DataNode) => {
            if (node.children && node.children.length === 0) { delete node.children; }
            else if (node.children) { node.children.forEach(clean); }
        };
        roots.forEach(clean);
        return roots;
    };

    const loadPlanCpList = async () => {
        try {
            const body = { CodeAgence: '', Table: 'PLANCP', Colonne1: 'IDPLAN', Colonne2: 'LIBELL', Colagence: '101', Init: '', choix: 22 };
            const res = await axios.get(Data.ApiUrl.AnySearch, {
                headers: {
                    Authorization: authHeader(),
                    'Content-Type': 'application/json',
                    'CypherSearch': Crypter.encrypt(JSON.stringify(body))
                }
            });
            const raw = JSON.parse(Crypter.decrypt(res.data));
            const value = raw.Value ?? raw;
            if (value.StatutCode === 200) {
                const rows = value.Result.Table || [];
                const list = rows.map((data: any) => ({
                    Code: data.IDPLAN?.toString() ?? Object.values(data)[0]?.toString() ?? '',
                    Libelle: data.LIBELL?.toString() ?? Object.values(data)[1]?.toString() ?? ''
                })).filter((x: any) => x.Code);
                setPlanCpList(list);
                setPlanCpTree(buildPlanCpTree(list));
            }
        } catch (ex: any) { console.log(ex); }
    };

    useEffect(() => {
        loadPlanCpList();
    }, []);

    useEffect(() => {
        if (!treeSearch) {
            setFilteredTree(planCpTree);
            setExpandedKeys([]);
            return;
        }
        const search = treeSearch.toLowerCase();
        const codeSet = new Set(planCpList.map(p => p.Code));
        const included = new Set<string>();
        const addParents = (code: string) => {
            included.add(code);
            for (let i = 1; i < code.length; i++) {
                const prefix = code.slice(0, -i);
                if (codeSet.has(prefix)) { addParents(prefix); break; }
            }
        };
        planCpList.forEach(p => {
            if (p.Code.toLowerCase().includes(search) || p.Libelle.toLowerCase().includes(search)) {
                addParents(p.Code);
            }
        });
        const filtered = planCpList.filter(p => included.has(p.Code));
        setFilteredTree(buildPlanCpTree(filtered));
        setExpandedKeys(filtered.map(p => p.Code));
    }, [treeSearch, planCpList, planCpTree]);

    const generateNewCode = (): boolean => {
        if (!selectedParent || !lastDigit) {
            setAddCodeError('Veuillez sélectionner un parent et saisir le dernier chiffre.');
            return false;
        }
        const newCode = selectedParent + lastDigit;
        if (planCpList.some(p => p.Code === newCode)) {
            setAddCodeError(`Le code plan ${newCode} existe déjà avec le libellé <<${planCpList.find(p => p.Code === newCode)?.Libelle}>>.`);
            return false;
        }
        // Récupérer le libellé du plan parent
        const parentPlan = planCpList.find(p => p.Code === selectedParent);
        const parentLibelle = parentPlan?.Libelle || '';
        form.setFieldsValue({ IDPLAN: newCode, lib_IDPLAN: parentLibelle });
        setAddCodeError(null);
        setLastDigit('');
        return true;
    };


    // Handle function
    function HandleConsult() {
        setConsulte(true);
        setAjoute(true);
        setModife(false);
        setAnnule(false);
        setSupprime(false);
        setIdbutton(true);
        SetActivetabs(true)
    }

    function HandleAjout() {
        setConsulte(true);
        setAjoute(true);
        setEnrege(false);
        setActue(false);
        setAnnule(false);
        setFormactve(false);
        setSbmit('add');

    }

    function HandleModif() {
        setEnrege(false);
        setModife(true);
        setActue(false);
        setAnnule(false)
        setFormactve(false);
        setSbmit('modif')
        setSupprime(true)
        SetActivetabs(false)
    }

    function HandleSupp() {
        setSbmit('supp')
    }

    function HandleAnnul() {

        setConsulte(false);
        setAjoute(false);
        setModife(true);
        setEnrege(true);
        setSupprime(true);
        setActue(true);
        setAnnule(true);
        form.resetFields();
        setFormactve(true);
        setSbmit('')
        setIdbutton(false);
        SetActivetabs(false)
    }

    // GESTION DES ITEMS
    const items: TabsProps['items'] = [
        {

            key: '1',
            label: (
                <span id='x'>
                    <UserOutlined />
                    Plan comptable
                </span>
            ),
            children: <>
                <div className='tabItem' >

                    <div style={{ display: 'block flow' }}  >

                        <Modal
                            title="Génération du code plan"
                            open={codeGenVisible}
                            onCancel={() => setCodeGenVisible(false)}
                            onOk={() => { if (generateNewCode()) setCodeGenVisible(false); }}
                            okText='Valider le code'
                            cancelText='Annuler'
                            width={900}
                        >
                            <Box style={{ padding: 12, backgroundColor: 'rgba(15,155,126,0.04)' }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <Typography variant='body2' color='text.secondary' style={{ marginBottom: 8 }}>
                                            Sélectionnez un plan parent dans l'arborescence :
                                        </Typography>
                                        <Input.Search
                                            placeholder='Rechercher un plan...'
                                            allowClear
                                            onChange={(e) => setTreeSearch(e.target.value)}
                                            style={{ marginBottom: 8 }}
                                        />
                                        <Box style={{ border: '1px solid #ddd', borderRadius: 6, padding: 8, backgroundColor: 'white', maxHeight: 250, overflow: 'auto' }}>
                                            <Tree
                                                treeData={filteredTree}
                                                showLine
                                                defaultExpandAll={!treeSearch}
                                                expandedKeys={expandedKeys}
                                                onExpand={(keys) => setExpandedKeys(keys)}
                                                onSelect={(keys) => setSelectedParent(keys[0] as string)}
                                                selectedKeys={selectedParent ? [selectedParent] : []}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <Typography variant='body2' color='text.secondary' style={{ marginBottom: 8 }}>
                                            Saisissez le dernier chiffre :
                                        </Typography>
                                        <Space direction='vertical' style={{ width: '100%' }}>
                                            <Input
                                                value={lastDigit}
                                                onChange={(e) => setLastDigit(e.target.value.replace(/[^0-9]/g, '').slice(0, 1))}
                                                style={{ width: "100%" }}
                                                placeholder='Chiffre'
                                                maxLength={1}
                                            />
                                            <center style={{ marginTop: "10%" }}>
                                                <Typography variant='body2' color='text.secondary'>
                                                    Code généré
                                                </Typography>
                                                
                                                <div style={{ backgroundColor: "#0a6a5545", margin: "5%", padding: "10%", borderRadius: "20px" }}>
                                                    <strong style={{ color: '#0a6a55', fontSize: "150%" }}>{selectedParent ? selectedParent + (lastDigit || 'X') : '—'}</strong>
                                                </div>
                                                {addCodeError && (
                                                    <Typography variant='body2' color='error' style={{ fontSize: 13 }}>
                                                        {addCodeError}
                                                    </Typography>
                                                )}
                                            </center>
                                        </Space>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Modal>

                        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}  >
                            <Box fontStyle="inherit" className='border-left '>
                                <Box style={{ display: 'flex' }}>


                                    <Box style={{ width: '50%' }}>
                                        <legend> Informations générales</legend>

                                        <Box style={{ marginBottom: -10, marginTop: -15 }}>
                                            {sbmit === 'add' && (
                                                <Box width={"100%"}>
                                                    <Button style={{ width: "100%" }} size="large" onClick={() => setCodeGenVisible(true)}>
                                                        Générer le code
                                                    </Button>
                                                    <br /><br />
                                                </Box>
                                            )}
                                        </Box>
                                        <Box style={{ marginBottom: -10, marginTop: -15 }}>
                                            <SearInputG width={6} dissabledLib={Idbutton} dissabledCode={Idbutton || (sbmit === 'add')} notremove notRequired Titre=" Recherche" label='Code Plan' name="IDPLAN" Taille1={'100%'} Taille2={'100%'} Parametre={searchPlancp}  /* etat={props.setSearchGlobal} */ form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, width: '100%' }}>
                                            <SearchModal width={6} Titre="" label="Type client" name="TYPCLI" Taille1={'100%'} Parametre={searchCtegoCli} Taille2={'100%'} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10 }}>
                                            <SearchModal width={6} Titre="" label="Catego compte" name="categocpt" Taille1={'100%'} Parametre={searchCtegoCpt} Taille2={'100%'} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10 }}>
                                            <SearchModal width={6} Titre="" label="Type de compte" name="TYPCPT" Taille1={'100%'} Parametre={searchTypCPT} Taille2={'100%'} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10 }}>
                                            <SearchModal width={6} Titre="" label="Fréquence relevé" name="FREIMP" Taille1={'100%'} Parametre={searchTypFre} Taille2={'100%'} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10 }}>
                                            <SearchModal width={6} Titre="" label="Sens du solde" name="sensSolde" Taille1={'100%'} Parametre={searchTypSens} Taille2={'100%'} form={form} />
                                        </Box>


                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                            <SearchModal width={6} notRequired Titre="" label="Code frais historique" name="codOpFraisHisto" Parametre={searchCommis2} Taille1={'100%'} Taille2={'100%'} form={form} />
                                        </Box>
                                    </Box>

                                    <Box style={{ marginLeft: 10, width: '50%' }}>
                                        <legend> informations spécificique </legend>
                                        <Box>
                                            {/* <Box style={{ marginTop: -10, width: '100%' }}>
                                                <SearchModal notRequired width={8} Titre="" label="Code frais SMS" name="codopSMS" Parametre={searchCommis2} Taille1={'100%'} Taille2={'100%'} form={form} />
                                            </Box> */}
                                            <Box style={{ marginTop: -10, width: '100%' }}>
                                                <SearchModal notRequired width={8} Titre="" label="Code frais ouverture" name="codope" Parametre={searchCommis2} Taille1={'100%'} Taille2={'100%'} form={form} />
                                            </Box>
                                            <Box style={{ marginTop: -10, width: '100%' }}>
                                                <SearchModal notRequired width={8} Titre="" label="code frais cloture" name="codopClo" Parametre={searchCommis2} Taille1={'100%'} Taille2={'100%'} form={form} />
                                            </Box>
                                        </Box>

                                        <Box style={{ display: 'flex' }}>
                                            <Box>
                                                <Box style={{ marginTop: -10, width: '100%' }}>
                                                    <InputForm width={12} label="Solde Minimum" type="number" name="SOLMIN" />
                                                </Box>
                                                <Box style={{ marginTop: -10, width: '100%' }}>
                                                    <InputForm width={12} label="Durée historique" type="number" name="TPSHIS" />
                                                </Box>
                                                <Box style={{ marginTop: -10, width: '100%' }}>
                                                    <InputForm width={12} label="Durée vie" type="number" name="DURVIE" />
                                                </Box>
                                                <Box style={{ marginTop: -10, width: '100%' }}>
                                                    <InputForm width={12} label="Jour dormance" type="number" name="JOUDOR" />
                                                </Box>

                                                <Box style={{ marginTop: -10, width: '100%' }}>
                                                    <InputForm width={12} label="Minimum Ouverture" money type="number" name="SOLMINOPEN" />
                                                </Box>

                                            </Box>
                                            <Box>
                                                <Box style={{ marginTop: -10, width: '100%' }}>
                                                    <InputForm width={13} label="Nbre mouvement crédit" type="number" name="NBRCRE" />
                                                </Box>
                                                <Box style={{ marginTop: -10, width: '100%' }}>
                                                    <InputForm width={13} label="Nbre mouvement débit" type="number" name="NBRDEB" />
                                                </Box>
                                                <Box style={{ marginTop: -10, width: '100%' }}>
                                                    <InputForm width={13} label="Niveau Consultation historique" type="number" name="NIVCONS" />
                                                </Box>
                                                <Box style={{ marginTop: -10, width: '100%' }}>
                                                    <InputForm notRequired width={13} label="Code produit" type="text" name="codprod" />
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                                <Box style={{ marginTop: 0 }}>
                                    <legend> Autres informations </legend>
                                    <Box style={{ display: 'flex', marginLeft: 17 }}>
                                        <Box>

                                            <Box >
                                                <CheckStan width={20} label={"Classe bloquée a la caisse ?"} name={"isbloqCai"} />
                                            </Box>

                                            <Box style={{ marginTop: -30 }}>
                                                <CheckStan width={20} label={"Classe bloquée en Back Office ?"} name={"isbloqSai"} />
                                            </Box>

                                            <Box style={{ marginTop: -30 }}>
                                                <CheckStan defauldVal={0} width={20} label={"InterAgence Bloquée a la caisse ?"} name={"IsInterAgceBloqCai"} />
                                            </Box>

                                            <Box style={{ marginTop: -30 }}>
                                                <CheckStan defauldVal={0} width={20} label={"InterAgence bloquée en Backoffice ?"} name={"IsInterAgceBloqSai"} />
                                            </Box>
                                            <Box style={{ marginTop: -30 }}>
                                                <CheckStan defauldVal={false} width={20} label={"Dormance en débit ?"} name={"joudordeb"} />
                                            </Box>

                                            <Box style={{ marginTop: -30 }}>
                                                <CheckStan defauldVal={false} width={20} label={"Dormance en crébit ?"} name={"joudorcrb"} />
                                            </Box>

                                        </Box>

                                        <Box style={{ marginLeft: 20 }}>

                                            <Box >
                                                <CheckStan width={19} label={"Classe regroupé au bilan "} name={"REGPTBILAN"} />
                                            </Box>

                                            <Box style={{ marginTop: -30 }}>
                                                <CheckStan width={19} label={"Classe regroupé a la balance"} name={"REGPTBAL"} />
                                            </Box>

                                            <Box style={{ marginTop: -30 }}>
                                                <CheckStan width={19} label={"Classe regroupé au cpt de Gestion"} name={"REGPTSOL"} />
                                            </Box>

                                            <Box style={{ marginTop: -30 }}>
                                                <CheckStan width={19} label={"Saisie des cptes d'amortissement"} name={"ISCPTAMORT"} />
                                            </Box>
                                            <Box style={{ marginTop: -30 }}>
                                                <CheckStan width={19} label={"Controle numéros de chéque"} name={"ICDVCH"} />
                                            </Box>
                                            
                                            <Box style={{ marginTop: -30 }}>
                                                <CheckStan width={19} label={"Prélévation des frais d'SMS"} name={"isPaieSms"} />
                                            </Box>

                                        </Box>

                                        <Box style={{ marginLeft: 20 }}>
                                            <Box style={{ marginTop: -10 }}>
                                                <SearchModal width={8} notRequired Titre="" label="Id Plan comptable Relié 1" name="IDPLANCP1" Parametre={searchPlancp} Taille1={'100%'} Taille2={'100%'} form={form} />
                                            </Box>
                                            <Box style={{ marginTop: -10 }}>
                                                <SearchModal width={8} notRequired Titre="" label="Id Plan comptable Relié 2" name="IDPLANCP2" Parametre={searchPlancp} Taille1={'100%'} Taille2={'100%'} form={form} />
                                            </Box>
                                            <Box style={{ marginTop: -10 }}>
                                                <SearchModal width={8} notRequired Titre="" label="Id Plan comptable Relié 3" name="IDPLANCP3" Parametre={searchPlancp} Taille1={'100%'} Taille2={'100%'} form={form} />
                                            </Box>
                                            <Box style={{ marginTop: -10 }}>
                                                <SearchModal width={8} notRequired Titre="" label="Id Plan comptable Relié 4" name="IDPLANCP4" Parametre={searchPlancp} Taille1={'100%'} Taille2={'100%'} form={form} />
                                            </Box>
                                            <Box style={{ marginTop: -10 }}>
                                                <SearchModal width={8} notRequired Titre="" label="Id Plan comptable Relié 5" name="IDPLANCP5" Parametre={searchPlancp} Taille1={'100%'} Taille2={'100%'} form={form} />
                                            </Box>

                                        </Box>


                                    </Box>
                                </Box>


                            </Box>

                        </Box>
                    </div>
                </div>
            </>,
        },
        {
            key: '2',
            label: (
                <span id='x2'>
                    <ContactsOutlined />
                    {/* Commissions et intérêts */}
                    Frais Gestion
                </span>
            ),
            children: <>
                <div className='tabItem' >
                    <div style={{ display: 'block flow', width: '100%' }}  >

                        <Box style={{ width: '80%' }}>

                            {/* <div style={{ width: '100%' }}>
                                <legend> Types d'intérêt </legend>
                                <Box style={{ display: 'flex', width: '100%' }}>
                                    <Box style={{ width: '100%' }} >
                                        <Box style={{ marginBottom: -10, marginTop: -20, width: '100%' }}>
                                            <SearchModal width={0} Titre="" notRequired label="Type intérêts 1" Parametre={searchTYIN} name="TYPIN1" Taille1={'100%'} Taille2={'100%'} form={form} />
                                        </Box>
                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                            <SearchModal width={0} Titre="" notRequired label="Type intérêts 2" Parametre={searchTYIN} name="TYPIN2" Taille1={'100%'} Taille2={'100%'} form={form} />
                                        </Box>
                                    </Box>
                                    <Box style={{ width: '100%' }}>
                                        <Box style={{ marginTop: -20, width: '100%' }}>
                                            <SearchModal width={0} Titre="" notRequired label="Type intérêts 3" Parametre={searchTYIN} name="TYPIN3" Taille1={'100%'} Taille2={'100%'} form={form} />
                                        </Box>
                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                            <SearchModal width={0} Titre="" notRequired label="Type intérêts 4" Parametre={searchTYIN} name="TYPIN4" Taille1={'100%'} Taille2={'100%'} form={form} />
                                        </Box>
                                    </Box>
                                    <Box style={{ width: '100%' }}>
                                        <Box style={{ marginTop: -20, width: '100%' }}>
                                            <SearchModal width={0} Titre="" notRequired label="Type intérêts 5" Parametre={searchTYIN} name="TYPIN5" Taille1={'100%'} Taille2={'100%'} form={form} />
                                        </Box>
                                    </Box>
                                </Box>
                            </div> */}

                            <div style={{ marginLeft: 10, width: '100%' }}>
                                <legend> Types Commissions </legend>
                                <Box style={{ display: 'flex', width: '100%' }}>
                                    <div style={{ width: '100%' }}>
                                        <Box style={{ marginBottom: -10, marginTop: -17, width: '100%' }}>
                                            <SearchModal width={0} Titre="" notRequired label="Frais Gestion 1" name="TYPCO1" Parametre={searchCommis} Taille1={'100%'} Taille2={'100%'} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, width: '100%' }}>
                                            <SearchModal width={0} Titre="" notRequired label="Frais Gestion 2" name="TYPCO2" Parametre={searchCommis} Taille1={'100%'} Taille2={'100%'} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, width: '100%' }}>
                                            <SearchModal width={0} Titre="" notRequired label="Frais Gestion 3" name="TYPCO3" Parametre={searchCommis} Taille1={'100%'} Taille2={'100%'} form={form} />
                                        </Box>
                                    </div>
                                    <div style={{ width: '100%' }}>
                                        <Box style={{ marginBottom: -10, marginTop: -17, width: '100%' }}>
                                            <SearchModal width={0} Titre="" notRequired label="Frais Gestion 4" name="TYPCO4" Parametre={searchCommis} Taille1={'100%'} Taille2={'100%'} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, width: '100%' }}>
                                            <SearchModal width={0} Titre="" notRequired label="Frais Gestion 5" name="TYPCO5" Parametre={searchCommis} Taille1={'100%'} Taille2={'100%'} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, width: '100%' }}>
                                            <SearchModal width={0} Titre="" notRequired label="Frais Gestion 6" name="TYPCO6" Parametre={searchCommis} Taille1={'100%'} Taille2={'100%'} form={form} />
                                        </Box>
                                    </div>

                                    <div style={{ width: '100%' }}>

                                        <Box style={{ marginBottom: -10, marginTop: -17, width: '100%' }}>
                                            <SearchModal width={0} Titre="" notRequired label="Frais Gestion 7" name="TYPCO7" Parametre={searchCommis} Taille1={'100%'} Taille2={'100%'} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, width: '100%' }}>
                                            <SearchModal width={0} Titre="" notRequired label="Frais Gestion 8" name="TYPCO8" Parametre={searchCommis} Taille1={'100%'} Taille2={'100%'} form={form} />
                                        </Box>
                                        <Box style={{ marginBottom: -10, width: '100%' }}>
                                            <SearchModal width={0} Titre="" notRequired label="Frais Gestion 9" name="TYPCO9" Parametre={searchCommis} Taille1={'100%'} Taille2={'100%'} form={form} />
                                        </Box>
                                    </div>

                                </Box>
                            </div>
                        </Box>


                    </div>
                </div>
            </>,
        },
        // {
        //     key: '3',
        //     label: (
        //         <span id='x3'>
        //             <ProfileOutlined />
        //             Création Batch via PCEMF
        //         </span>
        //     ),
        //     children: <Form disabled={false}><TabBatchPCEMF ref={tabBatchRef} /></Form>,
        // }
    ];


    // // consult 
    // function Consult() {

    //     if (form.getFieldValue('AAA') == 'okokokok') {
    //         alert('vrai')
    //     } else {
    //         alert('faux')
    //     }

    // }

    // function consult 
    function consult() {

        if (form.getFieldValue("IDPLAN") == null) {

            SweetAlert.fire({ title: "Svp renseigner le numero du plan Comptable", icon: "warning" });

        } else {
            HandleConsult();
            let data = (form.getFieldValue("IDPLAN"));
            let data2 = Perss.codage;

            if (data.length != 0) {
                setLoading(true)
                form.resetFields()
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.ReadPlanCp2,
                    headers: {
                        'CypherIdPLan': data,
                        'CypherCodeage': data2,
                        'Authorization': authHeader(),
                        'Content-Type': 'application/json'
                    },
                };

                axios.request(config)
                    .then((response) => {
                        setLoading(false);
                        if (response.data) {
                            //const res = JSON.parse(Crypter.decrypt(response.data));
                            const res = JSON.parse(Crypter.decrypt(response.data));
                            //console.log(JSON.stringify(res))
                            let DemandVP = res.Result.Table[0]
                            //console.log(DemandVP);

                            if (res.StatutCode == 200) {
                                form.setFieldsValue(DemandVP);
                                form.setFieldValue("lib_IDPLAN", DemandVP.LIBELL)
                            }
                            else {
                                SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                            }
                        }
                        setLoading(false)
                    })
                    .catch((error) => {
                        setLoading(false);
                        console.log(error)
                        SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                    });
            }
        }
    }


    // function Onfinish
    const onFinish = (values: any) => {

        //console.log(values)
        var DemandVP: Demand = values

        DemandVP.LIBELL = form.getFieldValue("lib_IDPLAN")
        DemandVP.DATCRE = formatDate(Perss.datjour)
        DemandVP.DATMOD = formatDate(Perss.datjour)
        DemandVP.UTILIS = Perss.coduti;
        DemandVP.joudordeb = form.getFieldValue("joudordeb") ? true : false;
        DemandVP.joudorcrb = form.getFieldValue("joudorcrb") ? true : false;
        DemandVP.ICDVCH = form.getFieldValue("ICDVCH") ? true : false;

        DemandVP.codage = Perss.codage

        console.log(DemandVP)

        if (sbmit == "add") {

            DemandVP.codage = Perss.codage
            DemandVP.CTLNUMCHQ = false
            //DemandVP.REGPTBILAN  = false
            //DemandVP.REGPTBAL  = false
            //DemandVP.ISCPTAMORT = false
            //DemandVP.REGPTSOL =false

            SweetAlert.fire({
                title: "Création d'un Plan Comptable " + DemandVP.IDPLAN,
                text: "Voulez-vous Créer le Plan Comptable" + DemandVP.LIBELL,
                showCancelButton: true,
                color: "green",
                confirmButtonText: "Yes",
                confirmButtonColor: "green",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: "question"
            }).then((res) => {

                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)
                    //console.log(JSON.stringify(DemandVP));
                    let data = Crypter.encrypt(JSON.stringify(DemandVP));
                    let config = {
                        method: 'post',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.CreatePlanCp,
                        headers: {
                            'CypherPlancp': data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };

                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                //console.log(res)
                                if (res.StatutCode == 200) {
                                    let code = res.Result
                                    form.resetFields()
                                    setIsSubmit(false)
                                    HandleAnnul()
                                    SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                        });
                }
            })
        }

        if (sbmit == "modif") {

            DemandVP.DATMOD = formatDate(Perss.datjour)
            DemandVP.UTILIS = Perss.coduti
            DemandVP.choix = "U"

            console.log(DemandVP);

            SweetAlert.fire({
                title: "M.A.J d'un Plan Comptable",
                text: "Voulez-vous mettre a jour ce Plan Comptable",
                showCancelButton: true,
                color: "green",
                confirmButtonText: "Yes",
                confirmButtonColor: "green",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: "question"
            }).then((res) => {

                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)
                    //console.log(JSON.stringify(DemandVP));
                    let data = Crypter.encrypt(JSON.stringify(DemandVP));
                    let config = {
                        method: 'put',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.UpdatePlanCp,
                        headers: {
                            'CypherPlancp': data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };

                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                //console.log(res)
                                if (res.StatutCode == 200) {
                                    let code = res.Result
                                    if (res.Message == "Erreur") {
                                        SweetAlert.fire({ title: "Svp préciser le type de modification", icon: "warning" })
                                        //HandleAnnul()
                                    } else {
                                        setIsSubmit(false)
                                        HandleAnnul()
                                        SweetAlert.fire({ title: "Mise à jour effectuée avec Success", text: "Code : " + res.Message, icon: "success" })
                                    }
                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                        });
                }
            })
        }

        if (sbmit == "supp") {

            SweetAlert.fire({
                title: "suppression Plan Comptable",
                text: "Voulez-vous supprimer ce Plan Comptable",
                showCancelButton: true,
                color: "green",
                confirmButtonText: "Yes",
                confirmButtonColor: "green",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: "question"
            }).then((res) => {

                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)
                    //console.log(JSON.stringify(DemandVP));
                    let data = Crypter.encrypt(JSON.stringify(DemandVP.IDPLAN));
                    let config = {
                        method: 'delete',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.deletePlanCp,
                        headers: {
                            'CypherIdPLan': DemandVP.IDPLAN,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };

                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                //console.log(res)
                                if (res.StatutCode == 200) {
                                    let code = res.Result
                                    if (res.Message == "Erreur") {
                                        SweetAlert.fire({ title: "Svp préciser le type de modification", icon: "warning" })
                                        //HandleAnnul()
                                    } else {
                                        setIsSubmit(false)
                                        HandleAnnul()
                                        SweetAlert.fire({ title: "Mise à jour Effectuer avec Success", text: "Code : " + res.Message, icon: "success" })
                                    }
                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                        });
                }
            })
        }
    }


    // function de verification 
    const onFinishFailed = async (errorInfo: any) => {
        var errors: any = [];
        errorInfo.errorFields.map((error: any) => {
            errors.push(error.name + "");
        })

        SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
    };

    const verifSubmit = () => {
        if (!isSubmit) {
            Swal.fire({ title: "Attention", text: "Veillez remplir tous les champs", icon: "warning" })
        }
    };


    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'> <b> {window.location.pathname} </b> </Typography>
            <Spin spinning={loading} size='large' style={{ color: 'green' }}>
                <Form disabled={FormAct} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add' disabled={Consultactv} onClick={() => { HandleConsult(); consult(); }} type="ghost" htmlType="button" block  >
                                    Consulter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Ajoutactv} onClick={() => { HandleAjout() }} type="ghost" htmlType="button" block  >
                                    Ajouter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Modifactv} onClick={() => { HandleModif() }} type="ghost" htmlType="button" block  >
                                    Modifier
                                </Button>
                                <Button size='large' className='bt_add' disabled={Enregactv} type="ghost" htmlType="submit" block>
                                    Enregistrer
                                </Button>
                                {/* <Button size='large' className='bt_add' disabled={activeTab !== '3'} onClick={() => { setBatchSaveVisible(true) }} type="ghost" htmlType="button" block>
                                    Enreg. le Batch
                                </Button> */}
                                <Button size='large' className='bt_add' disabled={Supprimactv} onClick={() => { HandleSupp() }} type="ghost" htmlType="submit" block>
                                    Supprimer
                                </Button>
                                <Button size='large' className='bt_add' disabled={Actuactv} onClick={() => { form.resetFields() }} type="ghost" htmlType="button" block  >
                                    Actualiser
                                </Button>
                                <Button size='large' disabled={Annulactv} onClick={() => { HandleAnnul() }} className='bt_add' type="ghost" htmlType="reset" block>
                                    Annuler
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div>

                            <div >
                                <Tabs onChange={e => { setActiveTab(e); if (Activetabs == true) { consult() } }} size='large' type="card" defaultActiveKey="1" items={items} />
                            </div>


                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );


}

export default PlanCp;